import common from '@page/common/js/common';
// import Pagination from "@page/common/js/Pagination";
import Pagination from '@global/components/global/Pagination';
import wishBtn from '@global/components/member/wishBtn';
import Slick from '@global/vendors/vue-slick';
import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';

// eslint-disable-next-line import/no-unresolved
import SortApp from '@page/shop/components/SortApp.vue';
import Vue from 'vue';
import $ from 'jquery';
import axios from 'axios';

require('@global/vendors/jquery.sticky-kit');

Vue.config.devtools = true;

const appPagination = new Vue({
  el: '#pagination',
  components: {
    Pagination,
  },
  template: '<Pagination :type="true"></Pagination>',
});

const appShop = new Vue({
  el: '#app-shop',
  components: {
    wishBtn,
    SortApp,
  },
  data: {
    largeMode: false,
    sortConditionData: null,
    sortConditionIsLoad: false,
    bannerSliderConfig: {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 6000,
    },
  },
  created() {
    this.getSortCondition();
  },
  mounted() {
    if ($('.banner-slide').length) {
      $('.banner-slide').slick(this.bannerSliderConfig);
    }
  },
  methods: {
    fireGTM(customMarketID, size) {
      fireShopListClickGTMEvent({ customMarketID, size });
    },
    getSortCondition() {
      axios
        .get(API_URL.SORT_POPUP)
        .then((res) => {
          if (res.data.Code === 200) {
            this.sortConditionData = res.data.Response;
            this.sortConditionIsLoad = true;
          }
        })
        .catch((error) => {});
    },
  },
});

if ($('.item-box').length > 3) {
  $('#category-sidebar').stick_in_parent({ offset_top: 200 });
}

fireShopListViewEvent();
